import {CHANNELS_RESOURCE} from '../api/resources';
import {addResource, deleteResource, fetchResource, updateResource} from './remote';
import { API_ROOT } from "signoxe/constants/config";
import { fetchAll } from "signoxe/actions/fetchAll";
import { actions as notifActions } from "redux-notifications";

export const fetchChannels = fetchResource(CHANNELS_RESOURCE);
export const addChannel = addResource(CHANNELS_RESOURCE);
export const cloneChannel = addResource(CHANNELS_RESOURCE, 'clone');
export const updateChannel = updateResource(CHANNELS_RESOURCE);
export const deleteChannel = deleteResource(CHANNELS_RESOURCE);

const getAuthTokenHeader = () => `Bearer ${localStorage.getItem("token")}`;
const { notifSend } = notifActions;


export const bulkDeleteChannel = (data) => (dispatch) => {
    var sentData = {
      data: data,
    };
  
    if (data.length == 0) {
      dispatch(
        notifSend({
          message: "No Channel(s) Selected!",
          kind: "alert",
          dismissAfter: 5000,
        })
      );
      return;
    }
  
    const url = `${API_ROOT}bulk_delete/channel/`;
    const options = {
      method: "DELETE",
      headers: {
        Authorization: getAuthTokenHeader(),
        Accept: "application/json",
        "Content-Type": "application/json",
      },
  
      body: JSON.stringify(sentData),
    };
    fetch(url, options)
      .then((response) => {
        dispatch(fetchChannels());
        if (response.status == 500) {
          alert("Something went wrong");
        }
      })
      .catch((err) => {
        alert(err);
      });
};
  
export const bulkUpdateChannel = (data) => (dispatch) => {
    var sentData = {
      data: data,
    };
    if (data.length == 0) {
      dispatch(
        notifSend({
          message: "No Channel(s) Edited!.",
          kind: "alert",
          dismissAfter: 5000,
        })
      );
      return;
    }
  
    const url = `${API_ROOT}bulk_update/channel/`;
    const options = {
      method: "PATCH",
      headers: {
        Authorization: getAuthTokenHeader(),
        Accept: "application/json",
        "Content-Type": "application/json",
      },
  
      body: JSON.stringify(sentData),
    };
    fetch(url, options)
      .then((response) => {
        dispatch(fetchChannels());
        if (response.status == 400) {
          alert("Invalid");
        }
      })
      .catch((err) => {
        alert(err);
      });
  };


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/actions/channel.js